import { render } from "./TeamCreate.vue?vue&type=template&id=c16d288e"
import script from "./TeamCreate.vue?vue&type=script&lang=js"
export * from "./TeamCreate.vue?vue&type=script&lang=js"
script.render = render

export default script